export const MSG_ENABLE_ACTION = "Msg Enable Action";
export const MSG_DISABLE_ACTION = "Msg Disable Action";
export const ROOM_ID_SET_ACTION = "Room Id Set Action";
export const ROOM_ID_REMOVE_ACTION = "Room Id Remove Action";
export const SET_USER_ACTION = "Set user Action";

const initialState = {
	isMsgOpen: false,
	roomId: null,
	selectedUser: {},
};

export function MsgReducer(state = initialState, action) {
	if (action.type === MSG_ENABLE_ACTION) {
		return {
			...state,
			isMsgOpen: true,
		};
	}

	if (action.type === MSG_DISABLE_ACTION) {
		return {
			...state,
			isMsgOpen: false,
		};
	}
	if (action.type === ROOM_ID_SET_ACTION) {
		return {
			...state,
			roomId: action.payload,
		};
	}
	if (action.type === ROOM_ID_REMOVE_ACTION) {
		return {
			...state,
			roomId: null,
		};
	}

	if (action.type === SET_USER_ACTION) {
		return {
			...state,
			selectedUser: action.payload,
		};
	}

	return state;
}
